import readOnlyLayout from "../helpers/readOnlyLayout";

function getView() {
  return readOnlyLayout({
    model: "melhous.item_service",
    activeSearch: false,
    target: "service",
    domain: [],
    fields: {
      title: { type: "char" },
      description: { type: "text" },
      icon: { type: "char" },
    },
    list: [{ name: "title" }, { name: "description" }],
    form: [{ name: "title" }, { name: "description" }, { name: "icon" }],
  });
}

export default { ctxView: getView };
